var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"result-display-title text-center"},[_vm._v(_vm._s(_vm.title))])],1),_c('v-row',[_c('v-col',{staticClass:"result-display-text text-center"},[_vm._v(_vm._s(_vm.value))])],1),_c('v-row',[_c('v-col',{staticClass:"result-display-change text-center"},[_vm._v(_vm._s(_vm.change))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }